import httpService from "..";

export const searchUsersApi = async (groupId: string, search: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/user/search?search=${search}&groupId=${groupId}`,
    "get"
  );
};

export const getUsersApi = async (groupId: any) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/user?groupId=${groupId}`,
    "get"
  );
};

export const getRolesApi = async () => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/role`,
    "get"
  );
};

export const getUserApi = async (id: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/user/${id}`,
    "get"
  );
};

export const getCompanyUsersApi = async (groupId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/user/group/${groupId}`,
    "get"
  );
};

export const addUserApi = async (data: {}) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/user`,
    "post",
    data
  );
};

export const readdUserApi = async (id: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/user/resend/${id}`,
    "post"
  );
};

export const editUserApi = async (id: string, data: any) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/user/${id}`,
    "patch",
    data
  );
};

export const editUserLoginApi = async (id: string, data: any) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/user/${id}/update-login`,
    "patch",
    data
  );
};

export const removeUserApi = async (id: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/user/${id}`,
    "delete"
  );
};
